module.exports = __webpack_public_path__ + "static/img/service_center.6f82ad7c.jpg";